export const notFoundErr = "NOT_FOUND"
export const manyResultsErr = "MANY_RESULTS"